import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import PartMain from './part-main';
import PartPostback from './part-postback';
import PartPostbackLog from './part-postback-log';
import PartAdditional from './part-additional';

lessRequire('modules/streams/components/stream-form/main.less');

const Form = props => {
	const {handleSubmit, saveForm, cloneCampaign, isEditMode, canEdit} = props;
	const formSubmit = handleSubmit(formData => {
		if (isEditMode && !canEdit)
			cloneCampaign();
		else
			return saveForm(formData);
	});

	return (
		<form action="" className="stream-form" onSubmit={formSubmit}>
			<PartMain {...props} formSubmit={formSubmit}/>
			<PartPostback {...props} onChecked={props.checked}/>
			<PartPostbackLog {...props} />
			<PartAdditional {...props} />
		</form>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	saveForm: PropTypes.func,
	cloneCampaign: PropTypes.func,
	postBackLogData: PropTypes.array,
	checked: PropTypes.func
};

export default reduxForm({
	form: 'streamForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/stream-form/main.js